<template>
	<div>
		<TopHeader :tabIndex='0'></TopHeader>
		
		<HomeIndex></HomeIndex>
		
		<Footer></Footer>
	</div>
</template>
<script>
	import TopHeader from "../components/TopHeader.vue";
	import Footer from "../components/Footer.vue";
	import HomeIndex from "./components/HomeIndex.vue";
	import {
		mapState
	} from "vuex";

	export default {
		name: "Index",
		data() {
			return {};
		},
		components: {
			TopHeader,
			Footer,
			HomeIndex
		},
		created() {
			
		},
		mounted() {},
		methods: {},
		computed: {
			...mapState(["permissionList"])
		},
		watch: {}
	};
</script>


<style>
	
</style>